import React from "../../__compat__/react/main.entry.mjs.mjs";
import { Text } from "../Text/index.mjs.mjs";
import { StyledTableHeadingCell } from "./Table.styles.mjs.mjs";
import { TableContext } from "./Table.context.mjs.mjs";
export const TableHeadingCell = React.forwardRef(({ children, colSpan, rowSpan, role, scope, width, }, ref) => {
    const tableContext = React.useContext(TableContext);
    return (React.createElement(StyledTableHeadingCell, { ref: ref, role: role, scope: scope, width: width, isColumnHeading: scope === 'col', colSpan: colSpan, rowSpan: rowSpan, displayMode: tableContext.displayMode },
        React.createElement(Text, { as: "span", variant: "copy1", weight: "bold" }, children)));
});
TableHeadingCell.displayName = 'TableHeadingCell';
export const withTableHeadingAccessibility = (WrappedComponent, { role, scope, displayName }) => {
    const component = React.forwardRef((props, ref) => {
        return (React.createElement(WrappedComponent, { role: role, scope: scope, ref: ref, ...props }, props.children));
    });
    component.displayName = displayName;
    return component;
};
//# sourceMappingURL=TableHeadingCell.mjs.mjs.map